import React, { useEffect, useMemo, useState } from "react";

import { Tab, Button, Modal } from "react-bootstrap";
import { useDataFetch } from "./../../hooks/useDataFetch";
import { useSelector } from "react-redux";
import { selectAuthToken } from "./../../store/selectors/AuthSelectors";
import ApiService from "./../../services/AxiosInstance";
import ConceptCreate from "../components/Concept/Create";
import CurrencyInput from "react-currency-input-field";
import { toast } from "react-toastify";
import { isEndDateAfterStartDate, isInteger } from "../utils";

const Concept = () => {
  const [yearFilter, setYearFilter] = useState(
    new Date().getFullYear().toString()
  );
  const [newConcept, setNewConcept] = useState(false);
  const [items, setItems] = useState([]);

  const token = useSelector(selectAuthToken);
  const [dataconcepts, setDataconcepts] = useState(null);
  const [datacostperiodics, setDatacostperiodics] = useState(null);

  const { getData, patchData, postData, invalidateQuery } = useDataFetch();

  const fetchConcepts = async () => {
    try {
      const response = await ApiService.get("/concepts", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDataconcepts(response.data);
    } catch (error) {
      console.error("Error fetching concepts:", error);
    }
  };

  const fetchCostPeriodics = async (y) => {
    try {
      const response = await ApiService.get("/cost-periodics", {
        headers: { Authorization: `Bearer ${token}` },
        params: { year: y || yearFilter },
      });
      setDatacostperiodics(response.data);
    } catch (error) {
      console.error("Error fetching cost periodics:", error);
    }
  };

  useEffect(() => {
    fetchConcepts();
  }, []);

  useEffect(() => {
    fetchCostPeriodics(yearFilter);
  }, [yearFilter]);

  const { mutate: createCostPeriodic, isLoading: isCreateLoading } = postData(
    "/cost-periodics",
    {},
    {},
    {
      onSuccess: (data) => {
        const result = data?.data?.data;
        setItems((prev) => {
          const index = prev.findIndex(
            (item) => result.concept_id == item.concept_id && result.year == item.year
          );
          prev[index].id = result.id;
          return [...prev];
        });
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const { mutate: updateCostPeriodic, isLoading: isUpdateLoading } = patchData(
    "/cost-periodics",
    {},
    {
      onSuccess: (data) => {
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  useEffect(() => {
    if (dataconcepts) {
      let items = [];
      for (const element of dataconcepts?.data ?? []) {
        let cost;
        if (datacostperiodics) {
          cost = datacostperiodics?.data?.find(
            (e) => e.concept_id == element.id && e.year == yearFilter
          );
        }
        items.push({
          id: cost ? cost.id : null,
          concept_id: element.id,
          concept: element.name,
          year: yearFilter,
          value: cost ? cost.value : null,
          start_date: cost ? cost.start_date : null,
          end_date: cost ? cost.end_date : null,
        });
      }
      setItems(items);
    }
  }, [dataconcepts, datacostperiodics, yearFilter]);

  const save = (e) => {
    if (!e.value || !isInteger(e.value)) {
      toast.error("El valor no es correcto ");
      return;
    }
    if (e.start_date || e.end_date) {
      const valid_date = isEndDateAfterStartDate(e.start_date, e.end_date);
      if (!valid_date) {
        toast.error("Las fechas no son correctas");
        return;
      }
    }

    if (e?.id) {
      updateCostPeriodic(e);
    } else {
      createCostPeriodic(e);
    }
  };

  return (
    <Tab.Container defaultActiveKey="all">
      <div className="d-flex justify-content-between">
        <select
          className="form-control mb-3"
          onChange={(e) => setYearFilter(e.target.value)}
          value={yearFilter}
          style={{ width: 100 }}
        >
          {[2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>

        <Button
          className="btn btn-primary text-nowrap mb-3 ml-3"
          onClick={() => setNewConcept(true)}
        >
          <i className="fa fa-plus scale5 mr-3" aria-hidden="true" />
          Nuevo concepto
        </Button>
      </div>

      <div className="table-responsive">
        <table className="table card-table display dataTablesCard dataTable no-footer">
          <thead>
            <tr>
              <th>Año</th>
              <th style={{ width: 300 }}>Concepto</th>
              <th>Valor</th>
              <th>Fecha inicial</th>
              <th>Fecha final</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items?.map((e) => (
              <tr key={e.concept_id}>
                <td>{e.year}</td>
                <td>{e.concept}</td>
                <td>
                  <CurrencyInput
                    value={e.value}
                    className="form-control"
                    decimalsLimit={0}
                    decimalSeparator=","
                    groupSeparator="."
                    onValueChange={(value, name, values) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.concept_id === e.concept_id
                        );
                        prev[index].value = value;
                       
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={e.start_date ?? ""}
                    onChange={(value) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.concept_id === e.concept_id
                        );
                        prev[index].start_date = value.target.value;
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={e.end_date ?? ""}
                    onChange={(value) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.concept_id === e.concept_id
                        );
                        prev[index].end_date = value.target.value;
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <Button
                    type="button"
                    onClick={() => save(e)}
                    disabled={isCreateLoading || isUpdateLoading}
                  >
                    Guardar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Modal className="fade bd-example-modal-lg" show={newConcept} size="xl">
        <Modal.Header>
          <Modal.Title>Nuevo Concepto</Modal.Title>
          <Button
            variant=""
            className="close"
            onClick={() => setNewConcept(false)}
          >
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <ConceptCreate
            refetchConcept={() => {
              setNewConcept(false);
              fetchConcepts();
              fetchCostPeriodics();
            }}
          />
        </Modal.Body>
      </Modal>
    </Tab.Container>
  );
};

export default Concept;
